import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { CalendarModule } from 'primeng/calendar';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { FormsModule } from '@angular/forms';
import { OrganizationChartModule } from 'primeng/organizationchart';
import { ChartModule } from 'primeng/chart';
import { CardModule } from 'primeng/card';
import { InputNumberModule } from 'primeng/inputnumber';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { TextareaModule } from 'primeng/textarea';
import { SplitterModule } from 'primeng/splitter';
import { MenuModule } from 'primeng/menu';
import { SelectModule } from 'primeng/select';
import { TooltipModule } from 'primeng/tooltip';
import { AutoFocusModule } from 'primeng/autofocus';
import { FocusTrapModule } from 'primeng/focustrap';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    DialogModule,
    CalendarModule,
    OverlayPanelModule,
    OrganizationChartModule,
    ChartModule,
    CardModule,
    AutoCompleteModule,
    ButtonModule,
    TextareaModule,
    SplitterModule,
    TooltipModule,
    AutoFocusModule,
    FocusTrapModule
  ],
  declarations: [

  ],
  exports: [
    TableModule,
    InputTextModule,
    CheckboxModule,
    DialogModule,
    ProgressSpinnerModule,
    DropdownModule,
    MultiSelectModule,
    CalendarModule,
    OverlayPanelModule,
    OrganizationChartModule,
    ChartModule,
    CardModule,
    InputNumberModule,
    AutoCompleteModule,
    ButtonModule,
    TextareaModule,
    SplitterModule,
    MenuModule,
    SelectModule,
    TooltipModule,
    AutoFocusModule,
    FocusTrapModule
  ]
})
export class PrimeNgModule { }
